<template>
    <div id="funcionario-cadastro">
        <my-tour :steps="steps" name="steps-categorias-cadastro"></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Cadastro de categoria" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-categoria @newdata="handleDataCategoria($event)"></formulario-categoria>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right salvar-categoria-btn" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import { post } from '@/helpers/api';
    import FormularioCategoria from './Formulario';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';

    import MyTour from '@/components/common/MyTour.vue';
    import Auth from '@/store/auth';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import TourHelper from '@/helpers/tour';

    export default {
        components: {
            FormularioCategoria,
            TituloPagina,
            MyTour
        },
        data: () => ({
            formData: {
                categoria_nome: '',
            },
             steps: [
                {
                    parent: '#formCampos',
                    target: '#formCampos',
                    content: 'Para isso, basta preencher as informações da categoria!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        menu: false
                    }
                },
                {
                    parent: '.salvar-categoria-btn',
                    target: '.salvar-categoria-btn',
                    content: 'E clicar em salvar!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '#left-sidebar-nav',
                    target: '#ajuda',
                    content: 'Caso queira rever este tutorial, você pode clicar clicar em <b>Ajuda</b>, lá terá um botão para reiniciar o tour e a descrição dos itens que são abordados nele! Até breve!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: true,
                        route: '/',
                        subMenu: false,
                    }
                },
                {
                    parent: '',
                    target: '',
                    content: '',
                    params: { cargos: [PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false,
                    }
                },

                ],
        }),
        created(){
            // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }
            this.steps = TourHelper.createSteps(this.steps);
        },
        methods: {
            save() {
                if (this.formData.categoria_nome === '') {
                    Message.messageError('Nome é obrigatório!');
                    return;
                }

                let self = this;
                post('categoria', {
                    categoria_nome: this.formData.categoria_nome,
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/categorias', function () {});
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mais tarde.');
                });
            },
            handleDataCategoria(e) {
                [
                    this.formData.categoria_nome,
                ] = e;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/categorias/Cadastro.vue